type keyString = { [key: string]: string };

const dyte = {
  primary: {
    300: '#1A90FF',
    500: '#2160FD',
    700: '#054DFF',
    900: '#0635AA',
  },
  secondary: {
    1000: '#0B0B0B',
    900: '#191919',
    800: '#262626',
    700: '#474747',
  },
  textPrimary: {
    400: '#999999',
    300: '#b8b8b8',
    200: '#dddddd',
    100: '#F5F5F7',
  },
  logos: {
    google: '#DD4B39',
    linkedIn: '#0E76A8',
    apple: '#EEEEEE',
  },
  danger: {
    300: '#FF5A65',
    500: '#FF414D',
    700: '#FF2331',
  },
  warning: {
    500: '#FFC300',
  },
  success: {
    500: '#35F2B3',
  },
  videoBackground: '#1A1A1A',
  paginationDots: {
    active: 'rgba(160,160,160, 0.8)',
    inactive: 'rgba(160,160,160, 0.3)',
    wandActive: 'rgba(160,160,160, 0.9)',
  },
};
export default dyte;
